/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Continue_With_GoogleInputs */



/**
* | output |
* | --- |
* | "Continue with Google" |
*
* @param {Auth_Continue_With_GoogleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_continue_with_google = /** @type {((inputs?: Auth_Continue_With_GoogleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Continue_With_GoogleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit Google fortfahren")
	return /** @type {LocalizedString} */ ("Continue with Google")
});